
import { onUnmounted, ref, watch } from '@vue/composition-api';
import { useRoute, useRouter } from '@nuxtjs/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  initial: {
    key: "initial",
    required: false,
    type: Number,
    default: 0
  },
  stretchTabsByWidth: {
    key: "stretchTabsByWidth",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const current = ref(props.initial);
  const route = useRoute();
  const router = useRouter();
  watch(() => current.value, step => {
    if (step !== +route.value.query?.step) router.push({
      path: route.value.path,
      query: {
        step: step.toString()
      }
    });
  }, {
    immediate: true
  });
  watch(() => route.value.query, ({
    step
  }) => {
    if (step === undefined) return emit('close');
    if (+step !== current.value) goTo(+step || 0);
  });
  onUnmounted(() => {
    router.push({
      path: route.value.path,
      query: {
        step: undefined
      }
    });
  });
  function next() {
    if (current.value === props.list.length - 1) {
      emit('complete');
    } else {
      current.value += 1;
      emit('next-step', current.value);
    }
  }
  function prev() {
    current.value = Math.max(0, current.value - 1);
  }
  function goTo(index: number) {
    if (index < current.value) current.value = Math.max(index, 0);
  }
  return {
    current,
    next,
    prev,
    goTo
  };
};
export default __sfc_main;
